import { useHistory } from "react-router-dom";
import { useState } from "react";
/**
 * Allows manipulating the history stack of the browser, making it easier to retain values in between browser refreshes and page navigations
 */
const useHistoryState = (key, initialValue) => {
    const history = useHistory();
    // Initialize state, checking if a value exists in history first, if so then return it
    const [rawState, rawSetState] = useState(() => {
        const historyState = history.location.state;
        if (historyState &&
            typeof historyState === "object" &&
            key in historyState) {
            // This double assertion is necessary to guarantee the type of the stored value
            // History.location.state type doesn't provide an exact type as it can accept anything. To validate our use case,
            // we first assert it as Record<string, never> to treat it as an object with string keys, then we assert the
            // retrieved value as T to match our expected type.
            return historyState[key];
        }
        // Otherwise, if provided, we use the initial value
        return initialValue;
    });
    function setState(value) {
        const historyState = history.location.state;
        const newState = historyState && typeof historyState === "object"
            ? Object.assign(Object.assign({}, historyState), { [key]: value }) : { [key]: value };
        // Update the browser history with the new state
        history.replace(Object.assign(Object.assign({}, history.location), { state: newState }));
        // Update the local state
        rawSetState(value);
    }
    return [rawState, setState];
};
export default useHistoryState;
